const styles = {
  cardImg: (isRightMost) => ({
    height: '140px',
    width: '359px',
    borderRadius: '10px',
    // margin: '0 10px 20px 0',
    position: 'relative',
    // padding: '1.25em',
    marginRight: `${isRightMost ? '0' : '1em'}`,
    boxShadow: '0em 0.125em 0.25em #0000001A',
    cursor: 'pointer'
    // background: 'white'
  }),
  promoContainer: {
    height: 'fit-content',
    display: 'inline-grid',
    // marginBottom: '3em',
    zIndex: 1
  },
  scrollmenu: {
    overflow: 'auto',
    whiteSpace: 'nowrap',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  carouselContainer: {
    width: '100%',
    display: 'flex',
    marginTop: '5px',
    justifyContent: 'flex-end'
  },
  carouselElement: (inViewPort = false) => ({
    backgroundColor: `${inViewPort ? '#0028AF' : 'rgb(125, 125, 125)'}`,
    marginRight: '2px',
    width: '10px',
    height: '2px',
    transitionTimingFunction: 'ease'
  })
}
export { styles }
